export class Address {
    line1: string;
    line2: string;
    city: string;
    postcode: string;

    isPopulated(): boolean {
        return this.line1 && this.line1.length > 0 && this.postcode && this.postcode.length > 0;
    }
}


// WEBPACK FOOTER //
// ./node_modules/angular2-template-loader!./Client/app/models/common/address.ts